import {Injectable} from '@angular/core';
import {ActivityListVO, ActivityVO} from './activity.interfaces';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {CrudEffects} from '@abydos-angular/store';
import {activityDefinition} from './activity.reducers';
import {ActivityRepository} from './activity.repository';

@Injectable()
export class ActivityEffects extends CrudEffects<ActivityVO, ActivityListVO> {

    /*
      Minta Effect
      SampleEffect = createEffect(() => this.actions.pipe(
        ofType({{action_type}}),
        switchMap(() => {
          return this.crudRepository.fgv().pipe(
            map((payload) => {
              return {payload: payload};
            })
            , toActionCreatorPayload(result_action, HandleErrorAction)
          );
        })
      )
    );
    */
    constructor(actions: Actions, private activityRepository: ActivityRepository) {
        super(actions, activityRepository, activityDefinition);
    }
}
